module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-screen3-15d886d1e2f54e856a62866bc1c36e0e.png";